export default __webpack_public_path__ + "static/media/home-bg.b4851911.png";